export default "__VITE_ASSET__du$y5iRy__"